export default __webpack_public_path__ + "static/media/rasm2.cc826ec3.jpg";